import { useFormContext } from 'react-hook-form';

import { type BlockedRecordStaffFormInput } from './schema';

export const useBlockedRecordStaffFormContext = useFormContext<BlockedRecordStaffFormInput>;
